const isUrlRegex = /^https?:\/\/.+/;

export default function isUrl(url) {
  return isUrlRegex.test(url);
}



// WEBPACK FOOTER //
// ./static/js/v0/utilities/isUrl.js